<template>
  <div id="termsDiv">
    <div class="container container--max-810">
      <div class="px-4">
        <div class="c-topbar-content c-topbar-content--compensate-borders">
          <div class="c-topbar-content__left">
            <mtg-header-link></mtg-header-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container container--max-810 mt-3 mt-md-4">
      <a @click="$router.go(-1)" class="c-link mt-2">
        <svg viewBox="0 0 14 20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <path
              d="M18.393 19.509L9.464 12l8.929-7.509a.5.5 0 0 0 .06-.704l-1.287-1.531a.5.5 0 0 0-.704-.06L6.168 10.851a1.5 1.5 0 0 0 0 2.296l10.294 8.657a.5.5 0 0 0 .704-.06l1.287-1.532a.5.5 0 0 0-.06-.704z"
              id="ic-angle-left_svg__a"
            />
          </defs>
          <use fill="currentColor" xlink:href="#ic-angle-left_svg__a" transform="translate(-5 -2)" fill-rule="evenodd" />
        </svg>
        <span>{{ $t("lang.label_back") }}</span>
      </a>
      <b-card>
        <b-card-title title-tag="h4">{{ $t("lang.label_termsAndConditions") }}</b-card-title>
        <b-card-text>
          <b-card-title title-tag="h5">{{ $t("lang.label_termsAndConditions_scopeOfApplication") }}</b-card-title>
          {{ $t("lang.label_termsAndConditions_scopeOfApplication_text_1") }} <i>quantum-safe certification authority platform</i>{{ $t("lang.label_termsAndConditions_scopeOfApplication_text_2") }}
        </b-card-text>
        <b-card-text>
          <b-card-title title-tag="h5">{{ $t("lang.label_termsAndConditions_conditionsOfUse") }}</b-card-title>
          <b-card-text>
            <b-card-title title-tag="h6">2.1</b-card-title>
            {{ $t("lang.label_termsAndConditions_conditionsOfUse_text21_1") }}
            <router-link :to="{ name: 'login-and-registration' }">pqc-pki.mtg.de</router-link>
            {{ $t("lang.label_termsAndConditions_conditionsOfUse_text21_2") }}
          </b-card-text>
          <b-card-text>
            <b-card-title title-tag="h6">2.2</b-card-title>
            {{ $t("lang.label_termsAndConditions_conditionsOfUse_text22_1") }}
            <a v-bind:href="'https://www.mtg.de/' + $store.state.locale + '/' + $t('lang.label_footer_dataPrivacy') + '/index.html'">{{
              $t("lang.label_termsAndConditions_conditionsOfUse_mtgPrivacyPolicy")
            }}</a>
            {{ $t("lang.label_termsAndConditions_conditionsOfUse_text22_2") }}
            <router-link :to="{ name: 'login-and-registration' }">pqc-pki.mtg.de</router-link>
            {{ $t("lang.label_termsAndConditions_conditionsOfUse_text22_3") }}
          </b-card-text>
          <b-card-text>
            <b-card-title title-tag="h6">2.3</b-card-title>
            {{ $t("lang.label_termsAndConditions_conditionsOfUse_text23") }}
          </b-card-text>
        </b-card-text>
        <b-card-text>
          <b-card-title title-tag="h5">{{ $t("lang.label_termsAndConditions_reservationOfModifications") }}</b-card-title>
          <b-card-text>
            {{ $t("lang.label_termsAndConditions_reservationOfModifications_text") }}
            <router-link :to="{ name: 'terms-conditions' }">pqc-pki.mtg.de/terms-conditions</router-link>
          </b-card-text>
        </b-card-text>
        <b-card-text>
          <b-card-title title-tag="h5">{{ $t("lang.label_termsAndConditions_reservationOfRightsOwnership") }}</b-card-title>
          <b-card-text>
            {{ $t("lang.label_termsAndConditions_reservationOfRightsOwnership_text") }}
          </b-card-text>
        </b-card-text>
        <b-card-text>
          <b-card-title title-tag="h5">{{ $t("lang.label_termsAndConditions_severabilityClause") }}</b-card-title>
          <b-card-text>
            {{ $t("lang.label_termsAndConditions_severabilityClause_text") }}
          </b-card-text>
        </b-card-text>
        <em>{{ $t("lang.label_termsAndConditions_status") }}</em>
      </b-card>
    </div>
  </div>
</template>

<script>
import MtgHeaderLink from "../components/layout/MtgHeaderLink";
export default {
  name: "TermsAndConditions",
  components: {
    MtgHeaderLink
  }
};
</script>

<style scoped></style>
